export default __webpack_public_path__ + "static/media/Stalker's Bracers of the Hidden Tomb.692bb754.jpg";